import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';
import { useToast } from '@/hooks/useToast';
import { AppRoutes } from '@/routes/AppRoutes';
import { ROUTES } from '@/routes/paths';
import { getEmailValidationError } from '@/utils/emailValidation';

function App() {
  const { login } = useAuth();
  const { showToast } = useToast();
  const navigate = useNavigate();

  const handleLogin = async (email, password) => {
    const emailError = getEmailValidationError(email);
    if (emailError) {
      showToast(emailError, 'error');
      return;
    }
    try {
      const loggedInUser = await login(email, password);
      if (loggedInUser.mustChangePassword) {
        navigate(ROUTES.changePassword, { replace: true });
      } else {
        navigate(ROUTES.dashboard(loggedInUser.role), { replace: true });
      }
    } catch (error) {
      showToast(error instanceof Error ? error.message : 'Login failed', 'error');
    }
  };

  return <AppRoutes onLogin={handleLogin} />;
}

export default App;
